import React from 'react';

const REVIEW_URL = "https://g.page/r/Ca1Dv59sJTIuEBM/review";
const TRIPADVISOR_URL = "https://www.tripadvisor.com/Restaurant_Review-g659633-d28127915-Reviews-Brunchi-Playa_Blanca_Lanzarote_Canary_Islands.html";

const GoogleReviewCTA = ({ variant = "inline" }) => {
  if (variant === "banner") {
    return (
      <section className="py-8 bg-gradient-to-r from-amber-50 to-yellow-50" data-testid="review-cta-banner">
        <div className="container mx-auto px-4 text-center">
          <div className="max-w-2xl mx-auto">
            <div className="flex items-center justify-center gap-1 mb-3">
              {[1,2,3,4,5].map(i => (
                <svg key={i} className="w-6 h-6 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                </svg>
              ))}
            </div>
            <p className="text-lg font-semibold text-gray-800 mb-1">Rated 4.9/5 on Google</p>
            <p className="text-gray-600 mb-4">Loved your visit? We'd really appreciate a review.</p>
            <div className="flex flex-wrap justify-center gap-3">
              <a
                href={REVIEW_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="google-review-btn"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium transition-colors text-sm"
              >
                <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor"><path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" /><path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" /><path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" /><path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" /></svg>
                Leave a Google Review
              </a>
              <a
                href={TRIPADVISOR_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="tripadvisor-review-btn"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-green-600 hover:bg-green-700 text-white rounded-lg font-medium transition-colors text-sm"
              >
                <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor"><circle cx="6.5" cy="13.5" r="2.5"/><circle cx="17.5" cy="13.5" r="2.5"/><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c2.69 0 5.14.95 7.07 2.52L17.59 9H6.41l-1.48-1.48A9.96 9.96 0 0112 5z"/></svg>
                Review on TripAdvisor
              </a>
            </div>
          </div>
        </div>
      </section>
    );
  }

  // Compact inline version
  return (
    <div className="flex flex-wrap gap-2" data-testid="review-cta-inline">
      <a href={REVIEW_URL} target="_blank" rel="noopener noreferrer"
         className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-blue-600 hover:bg-blue-700 text-white text-xs rounded-lg font-medium transition-colors">
        Leave a Google Review
      </a>
      <a href={TRIPADVISOR_URL} target="_blank" rel="noopener noreferrer"
         className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-green-600 hover:bg-green-700 text-white text-xs rounded-lg font-medium transition-colors">
        Review on TripAdvisor
      </a>
    </div>
  );
};

export default GoogleReviewCTA;
